module.exports = __webpack_public_path__ + "img/animated-notes-small.3f29b0c6.gif";